import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const MikrotikNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="mikrotik" />;
};
